module.exports = __webpack_public_path__ + "static/media/dokobit-logo.36ee53b2.svg";